import { gql } from '@apollo/client'
import React from 'react'

import { compliancesClient } from '../../../../../utils/apollo/api'
import { useModalData } from '../../../../../components/modals/ModalsContext'
import { usePaginatedQuery } from '../../../../../utils/apollo/_helpers/pagination'
import LazyAction from '../../../../../components/helpers/LazyAction'
import StatePresenter from '../../../../../components/helpers/StatePresenter'

const Context = React.createContext()
const { Provider } = Context
export const useEventsState = () => React.useContext(Context) || {}
export const useEvents = () => useEventsState()?.nonComplianceEvents || []

const QUERY = gql`
  query NonComplianceEvents($page: Int, $filter: NonComplianceEventFilter, $sort: [NonComplianceEventSort]) {
    nonComplianceEvents(page: $page, sort: $sort, filter: $filter) {
      id
      type
      insertedAt
      updatedAt
      reply {
        id
        value
        serviceOrderId
        formReplyId
        notes
        isNonCompliance
        questionId
        question {
          id
          name
          reference
          nonComplianceConditions
          typeName
          type {
            id
            name
          }
          category {
            id
            name
          }
        }
      }
      formReply {
        id
        number
        place {
          id
          name
          resume
        }
        form {
          id
          name
          checklist {
            id
            name
          }
        }
      }
      serviceOrder {
        id
        name
        yearlyId
        place {
          id
          name
          resume
        }
        status {
          id
          name
        }
        checklist {
          id
          name
        }
        user {
          id
          name
        }
        group {
          id
          name
        }
        endDate
      }
    }
  }
`

const EventsLoader = ({ children }) => {
  const ids = useModalData()

  const { data, fetchMore, ...state } = usePaginatedQuery(QUERY, {
    variables: {
      page: 1,
      sort: [{ field: 'INSERTED_AT', type: 'DESC' }],
      filter: { nonComplianceIds: ids, latestOnly: true }
    },
    client: compliancesClient
  })

  return (
    <Provider value={data}>
      <StatePresenter {...state}>
        {children}
        <LazyAction action={fetchMore} waiting={state.loading || state.isFetchingMore} />
      </StatePresenter>
    </Provider>
  )
}

export default EventsLoader
